import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

/* Layout */
import Layout from '@/layout';

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
  roles: ['admin','editor']    control the page roles (you can set multiple roles)
  title: 'title'               the name show in sidebar and breadcrumb (recommend set)
  icon: 'svg-name'             the icon show in the sidebar
  breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
  activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export var constantRoutes = [{
  path: '/',
  redirect: '/overview/index',
  hidden: true
}, {
  path: '/404',
  component: function component() {
    return import('@/views/404');
  },
  hidden: true
}, {
  path: '/login',
  component: function component() {
    return import('@/views/login/index');
  },
  hidden: true
}, {
  path: '/platformConfig',
  component: Layout,
  hidden: true,
  children: [{
    path: 'custom-layout',
    name: 'customLayoutTemplate',
    component: function component() {
      return import('@/views/platformConfig/templateLibrary/customLayout');
    },
    meta: {
      title: '商城首页装修'
    }
  }, {
    path: '/platformConfig/editCustomer',
    name: 'editCustomer',
    meta: {
      title: '客户列表'
    },
    component: function component() {
      return import('@/views/platformConfig/customer/editCustomer');
    }
  }, {
    path: '/platformConfig/orderDetails',
    name: 'platformConfig/orderDetails',
    meta: {
      title: '订单详情'
    },
    component: function component() {
      return import('@/views/platformConfig/orderDetails');
    }
  }]
}, {
  path: '/collectCard',
  component: Layout,
  hidden: true,
  children: [{
    path: 'list',
    name: 'collectCardList',
    component: function component() {
      return import('@/views/collectCard/list');
    },
    meta: {
      title: '领卡管理'
    }
  }, {
    path: 'detail',
    name: 'collectCardDetail',
    meta: {
      title: '详情'
    },
    component: function component() {
      return import('@/views/collectCard/detail');
    }
  }]
},
// 下载中心
{
  path: '/downLoadCenter',
  component: Layout,
  hidden: true,
  children: [{
    path: 'downLoadCenter',
    name: 'downLoadCenter',
    component: function component() {
      return import('@/views/downLoadCenter/downLoadCenterList');
    },
    meta: {
      title: '下载中心'
    }
  }]
},
// 代理管理
{
  path: 'agentManagement/userManagement/userManagementLis',
  component: Layout,
  redirect: '/agentManagement/userManagement/userManagementLis',
  hidden: true,
  meta: {
    title: '代理管理'
  },
  children: [{
    path: '/agentManagement/userManagement/agentEditUser',
    name: 'agentEditUser',
    component: function component() {
      return import('@/views/agentManagement/userManagement/agentEditUser');
    },
    hidden: true,
    meta: {
      title: '编辑用户'
    }
  }, {
    path: '/agentManagement/userManagement/createAgentUserInfo',
    name: 'createAgentUserInfo',
    component: function component() {
      return import('@/views/agentManagement/userManagement/createAgentUserInfo');
    },
    hidden: true,
    meta: {
      title: '创建用户'
    }
  }, {
    path: '/agentManagement/userManagement/agentEditRoles',
    name: 'agentEditUserPoles',
    component: function component() {
      return import('@/views/agentManagement/userManagement/agentEditRoles');
    },
    hidden: true,
    meta: {
      title: '角色授权'
    }
  }, {
    path: '/agentManagement/userManagement/agentEditData',
    name: 'agentEditData',
    component: function component() {
      return import('@/views/agentManagement/userManagement/agentEditData');
    },
    hidden: true,
    meta: {
      title: '数据权限'
    }
  }, {
    path: '/agentManagement/userManagement/agentLoginFlow',
    name: 'agentLoginFlow',
    component: function component() {
      return import('@/views/agentManagement/userManagement/agentLoginFlow');
    },
    hidden: true,
    meta: {
      title: '登录流水'
    }
  }]
},
// 平台报表
{
  path: '/platformReport',
  component: Layout,
  hidden: true,
  children: [{
    path: 'watchDetail',
    name: 'watchDetail',
    component: function component() {
      return import('@/views/platformReport/watchDetail');
    },
    meta: {
      title: '变价明细'
    }
  }, {
    path: 'watchGiftPackageStockListDetails',
    name: 'watchGiftPackageStockListDetails',
    component: function component() {
      return import('@/views/platformReport/giftPackageStockManagement/watchGiftPackageStockListDetails');
    },
    meta: {
      title: '缺货礼包列表'
    }
  }, {
    path: 'giftPackReplaceGoods',
    name: 'giftPackReplaceGoods',
    component: function component() {
      return import('@/views/platformReport/giftPackageStockManagement/giftPackReplaceGoods');
    },
    meta: {
      title: '商品替换列表'
    }
  }, {
    path: 'replaceGoodsAudit',
    name: 'replaceGoodsAudit',
    component: function component() {
      return import('@/views/platformReport/giftPackageStockManagement/replaceGoodsAudit');
    },
    meta: {
      title: '替换商品审核列表'
    }
  }, {
    path: 'orderConsumptionTrend',
    name: 'orderConsumptionTrend',
    component: function component() {
      return import('@/views/platformReport/orderConsumptionTrend');
    },
    meta: {
      title: ''
    }
  }, {
    path: 'shippingOrderDetails',
    name: 'shippingOrderDetails',
    component: function component() {
      return import('@/views/platformReport/shippingOrderDetails');
    },
    meta: {
      title: '备选发货单明细'
    }
  }, {
    path: 'presetCard',
    name: 'presetCard',
    component: function component() {
      return import('@/views/platformReport/presetCard');
    },
    meta: {
      title: '设置卡类型预设值'
    }
  }, {
    path: 'setOrderRiskControl',
    name: 'setOrderRiskControl',
    component: function component() {
      return import('@/views/platformReport/setOrderRiskControl');
    },
    meta: {
      title: '设置卡类型风控规则'
    }
  }, {
    path: 'abnormalTagsManage',
    name: 'abnormalTagsManage',
    component: function component() {
      return import('@/views/platformReport/abnormalTagsManage');
    },
    meta: {
      title: '订单标签管理'
    }
  }]
}, {
  path: '/channelManage',
  component: Layout,
  hidden: true,
  children: [{
    path: 'contractManage',
    name: 'contractManage',
    component: function component() {
      return import('@/views/channelManage/channelManagementList/contractManage');
    },
    meta: {
      title: '合同管理'
    }
  }, {
    path: 'channelOrderRules',
    name: 'channelOrderRules',
    hidden: true,
    component: function component() {
      return import('@/views/channelManage/channelManagementList/channelOrderRules');
    },
    meta: {
      title: '渠道订单规则'
    }
  }, {
    path: 'channelCardType',
    name: 'channelCardType',
    hidden: true,
    component: function component() {
      return import('@/views/channelManage/channelManagementList/channelCardType');
    },
    meta: {
      title: '卡类型配置'
    }
  }, {
    path: 'addChannel',
    name: 'addChannel',
    component: function component() {
      return import('@/views/channelManage/channelManagementList/addChannel');
    },
    meta: {
      title: '添加渠道'
    }
  }, {
    path: 'channelConfiguration',
    name: 'channelConfiguration',
    component: function component() {
      return import('@/views/channelManage/channelManagementList/channelConfiguration');
    },
    meta: {
      title: '配置'
    }
  }, {
    path: 'createBaseInfo',
    name: 'createBaseInfo',
    component: function component() {
      return import('@/views/channelManage/channelManagementList/createBaseInfo');
    },
    meta: {
      title: '基本信息配置'
    }
  }, {
    path: 'custom-layout/home',
    component: function component() {
      return import('@/views/custom-layout/home');
    },
    meta: {
      title: '商城配置目录',
      activeMenu: '/channelManage/channelManagementList/channelList'
    }
  }, {
    path: 'channelMenuList',
    name: 'channelMenuList',
    component: function component() {
      return import('@/views/channelManage/channelManagementList/channelMenuList');
    },
    meta: {
      title: '商城菜单管理'
    }
  }, {
    path: 'customerList',
    name: 'customerList',
    component: function component() {
      return import('@/views/channelManage/channelManagementList/customerList');
    },
    meta: {
      title: '客户管理'
    }
  }, {
    path: 'changeBalance',
    name: 'changeBalance',
    component: function component() {
      return import('@/views/channelManage/channelManagementList/changeBalance');
    },
    meta: {
      title: '余额变动记录'
    }
  }, {
    path: 'productCostJournal',
    name: 'productCostJournal',
    component: function component() {
      return import('@/views/channelManage/channelManagementList/productCostJournal');
    },
    meta: {
      title: '自营商品成本流水'
    }
  }, {
    path: 'transactionFlow',
    name: 'transactionFlow',
    component: function component() {
      return import('@/views/channelManage/channelManagementList/transactionFlow');
    },
    hidden: true,
    meta: {
      title: '交易流水'
    }
  }, {
    path: 'operationLog',
    name: 'operationLog',
    component: function component() {
      return import('@/views/channelManage/channelManagementList/operationLog');
    },
    hidden: true,
    meta: {
      title: '操作日志'
    }
  }, {
    path: 'smsBilling',
    name: 'smsBilling',
    component: function component() {
      return import('@/views/channelManage/message/smsBilling');
    },
    hidden: true,
    meta: {
      title: '短信账单',
      roles: []
    }
  }, {
    path: 'smsDetails',
    name: 'smsDetails',
    component: function component() {
      return import('@/views/channelManage/message/smsDetails');
    },
    hidden: true,
    meta: {
      title: '短信发送明细',
      roles: []
    }
  }, {
    path: 'createStatementAccount',
    name: 'createStatementAccount',
    component: function component() {
      return import('@/views/channelManage/channelManagementList/createStatementAccount');
    },
    hidden: true,
    meta: {
      title: '创建对账单'
    }
  }, {
    path: 'statementDetails',
    name: 'statementDetails',
    component: function component() {
      return import('@/views/channelManage/channelManagementList/statementDetails');
    },
    hidden: true,
    meta: {
      title: '对账单详情'
    }
  }, {
    path: 'statementWatchDetails',
    name: 'statementWatchDetails',
    component: function component() {
      return import('@/views/channelManage/channelManagementList/statementWatchDetails');
    },
    hidden: true,
    meta: {
      title: '对账单明细'
    }
  }, {
    path: 'previewAccount',
    name: 'previewAccount',
    component: function component() {
      return import('@/views/channelManage/channelManagementList/previewAccount');
    },
    hidden: true,
    meta: {
      title: '预览对账单'
    }
  }]
}, {
  path: '/custom-layout',
  component: Layout,
  hidden: true,
  children: [{
    path: 'home',
    component: function component() {
      return import('@/views/custom-layout/home');
    },
    meta: {
      title: '商城配置目录'
    }
  }, {
    path: 'styleConfig',
    component: function component() {
      return import('@/views/custom-layout/styleConfig');
    },
    meta: {
      title: 'C端商城风格设置'
    }
  }, {
    path: 'index',
    component: function component() {
      return import('@/views/custom-layout/index');
    },
    meta: {
      title: ''
    }
  }, {
    path: 'functionMenu',
    component: function component() {
      return import('@/views/custom-layout/functionMenu');
    },
    meta: {
      title: '功能菜单装修'
    }
  }, {
    path: 'childrenList',
    component: function component() {
      return import('@/views/custom-layout/childrenList');
    },
    meta: {
      title: '子页面管理页'
    }
  }, {
    path: 'indexChildren',
    component: function component() {
      return import('@/views/custom-layout/indexChildren');
    },
    meta: {
      title: '子页面装修'
    }
  }, {
    path: 'cardStyle',
    component: function component() {
      return import('@/views/custom-layout/cardStyle');
    },
    meta: {
      title: '卡包样式'
    }
  }, {
    path: 'cardStyleCustomer',
    component: function component() {
      return import('@/views/custom-layout/cardStyleCustomer');
    },
    meta: {
      title: '卡包样式'
    }
  }, {
    path: 'category',
    component: function component() {
      return import('@/views/custom-layout/category');
    },
    meta: {
      title: '分类页装修'
    }
  }, {
    path: 'popupSetting',
    component: function component() {
      return import('@/views/custom-layout/popupSetting');
    },
    meta: {
      title: '弹窗设置'
    }
  }, {
    path: 'popupSettingDetail',
    component: function component() {
      return import('@/views/custom-layout/popupSettingDetail');
    },
    meta: {
      title: '弹窗设置'
    }
  }, {
    path: 'personalCenter',
    component: function component() {
      return import('@/views/custom-layout/personalCenter');
    },
    meta: {
      title: '个人中心装修'
    }
  }, {
    path: 'superWidgetList',
    component: function component() {
      return import('@/views/custom-layout/superWidgetList');
    },
    meta: {
      title: '超级装修管理页'
    }
  }, {
    path: 'indexSuperWidget',
    component: function component() {
      return import('@/views/custom-layout/indexSuperWidget');
    },
    meta: {
      title: '超级组件装修'
    }
  }, {
    path: 'basicConfig',
    component: function component() {
      return import('@/views/custom-layout/basicConfig');
    },
    meta: {
      title: '基础装修配置'
    }
  }, {
    path: 'styleSaleConfig',
    component: function component() {
      return import('@/views/custom-layout/styleSaleConfig');
    },
    meta: {
      title: '商城首页装修'
    }
  }]
}, {
  path: '/serviceCenter',
  redirect: '/serviceCenter',
  component: Layout,
  hidden: true,
  children: [{
    path: 'cardDetails',
    name: 'cardDetails',
    hidden: true,
    meta: {
      title: '详细信息'
    },
    component: function component() {
      return import('@/views/serviceCenter/workBench/components/cardDetails');
    }
  }]
}, {
  path: '/platformQueryManage',
  redirect: '/platformQueryManage',
  component: Layout,
  hidden: true,
  children: [{
    path: 'platformCardDetails',
    name: 'platformCardDetails',
    hidden: true,
    meta: {
      title: '详细信息'
    },
    component: function component() {
      return import('@/views/platformQueryManage/workBench/components/cardDetails');
    }
  }, {
    path: 'cardRules',
    name: 'cardRules',
    hidden: true,
    meta: {
      title: '订单规则'
    },
    component: function component() {
      return import('@/views/platformQueryManage/workBench/cardRules');
    }
  }, {
    path: 'resetCardPwd',
    name: 'resetCardPwd',
    hidden: true,
    meta: {
      title: '重置卡密码'
    },
    component: function component() {
      return import('@/views/platformQueryManage/workBench/resetCardPwd');
    }
  }, {
    path: 'cardExtension',
    name: 'cardExtension',
    hidden: true,
    meta: {
      title: '人工卡延期'
    },
    component: function component() {
      return import('@/views/platformQueryManage/workBench/cardExtension');
    }
  }, {
    path: 'nicknameQuery',
    name: 'nicknameQuery',
    hidden: true,
    meta: {
      title: '微信昵称查询'
    },
    component: function component() {
      return import('@/views/platformQueryManage/workBench/nicknameQuery');
    }
  }]
}, {
  path: '/overview',
  redirect: '/overview/index',
  component: Layout,
  hidden: true,
  children: [{
    path: 'index',
    // name: 'overview',
    meta: {
      style: {
        backgroundColor: '#fff'
      }
    },
    component: function component() {
      return import('@/views/overview/index');
    }
  }]
},
// 管理中心  // manageCenter
{
  path: '/manageCenter/userManagement',
  component: Layout,
  redirect: '/manageCenter/userManagement/userManagementList',
  hidden: true,
  meta: {
    title: '管理中心',
    roles: ['/user/user/index']
  },
  children: [{
    path: '/manageCenter/userManagement/userManagementList',
    name: 'ManageUserManagementList',
    component: function component() {
      return import('@/views/manageCenter/userManagement/userManagementList');
    },
    meta: {
      title: '用户管理',
      keepAlive: true,
      roles: ['/user/user/index']
    }
  }, {
    path: '/manageCenter/userManagement/editUser',
    name: 'ManageEditUserManagement',
    component: function component() {
      return import('@/views/manageCenter/userManagement/editUser');
    },
    hidden: true,
    meta: {
      title: '编辑用户'
    }
  }, {
    path: 'createUserInfo',
    name: 'ManageCreateUserInfo',
    component: function component() {
      return import('@/views/manageCenter/userManagement/createUserInfo');
    },
    hidden: true,
    meta: {
      title: '创建用户'
    }
  }, {
    path: '/manageCenter/userManagement/editRoles',
    name: 'ManageEditUserPoles',
    component: function component() {
      return import('@/views/manageCenter/userManagement/editRoles');
    },
    hidden: true,
    meta: {
      title: '角色授权'
    }
  }, {
    path: '/manageCenter/userManagement/editData',
    name: 'ManageEditData',
    component: function component() {
      return import('@/views/manageCenter/userManagement/editData');
    },
    hidden: true,
    meta: {
      title: '数据权限'
    }
  }, {
    path: '/manageCenter/userManagement/loginFlow',
    name: 'ManageLoginFlow',
    component: function component() {
      return import('@/views/manageCenter/userManagement/loginFlow');
    },
    hidden: true,
    meta: {
      title: '登录流水'
    }
  }, {
    path: '/manageCenter/userInfo/loginStream',
    name: 'loginStream',
    component: function component() {
      return import('@/views/manageCenter/userInfo/loginStream');
    },
    hidden: true,
    meta: {
      title: '登录流水'
    }
  }, {
    path: '/manageCenter/accountBalanceLogList',
    name: 'accountBalanceLogList',
    component: function component() {
      return import('@/views/manageCenter/accountBalanceLogList');
    },
    hidden: true,
    meta: {
      title: '交易流水'
    }
  }, {
    path: 'addDirectoryManagement',
    name: 'manageCenterAddDirectoryManagement',
    component: function component() {
      return import('@/views/manageCenter/knowledgeBase/addDirectoryManagement');
    },
    hidden: true,
    meta: {
      title: '知识库目录新建'
    }
  }, {
    path: 'manageCenterKnowledgeBase',
    name: 'manageCenterAddKnowledge',
    component: function component() {
      return import('@/views/manageCenter/knowledgeBase/addKnowledge');
    },
    hidden: true,
    meta: {
      title: '添加知识库',
      roles: ['/orders/knowledge/index']
    }
  }, {
    path: 'viewKnowledge',
    name: 'manageCenterViewKnowledge',
    component: function component() {
      return import('@/views/manageCenter/knowledgeBase/viewKnowledge');
    },
    hidden: true,
    meta: {
      title: '查看知识库',
      roles: ['/orders/knowledge/index']
    }
  }, {
    path: '/manageCenter/message/smsSendingDetails',
    name: 'smsSendingDetails',
    component: function component() {
      return import('@/views/manageCenter/message/smsSendingDetails');
    },
    hidden: true,
    meta: {
      title: '短信发送明细',
      roles: []
    }
  }, {
    path: '/manageCenter/accountBalanceList/alertSettings',
    name: 'alertSettings',
    component: function component() {
      return import('@/views/manageCenter/alertSettings');
    },
    hidden: true,
    meta: {
      title: '余额预警设置',
      roles: []
    }
  }, {
    path: '/manageCenter/manageCenterStatementDetails',
    name: 'manageCenterStatementDetails',
    component: function component() {
      return import('@/views/manageCenter/accountReconciliationManagement/manageCenterStatementDetails');
    },
    hidden: true,
    meta: {
      title: '对账单详情'
    }
  }, {
    path: '/manageCenter/manageCenterStatementWatchDetails',
    name: 'manageCenterStatementWatchDetails',
    component: function component() {
      return import('@/views/manageCenter/accountReconciliationManagement/manageCenterStatementWatchDetails');
    },
    hidden: true,
    meta: {
      title: '对账单明细'
    }
  }]
}, {
  path: '/user',
  component: Layout,
  // redirect: '/order/cardTypeManage',
  hidden: true,
  children: [{
    path: 'changePassword',
    name: 'changePassword',
    hidden: true,
    component: function component() {
      return import('@/views/user/changePassword');
    }
  }, {
    path: 'changeSystem',
    name: 'changeSystem',
    hidden: true,
    component: function component() {
      return import('@/views/user/changeSystem');
    }
  }, {
    path: 'uploadAvatar',
    name: 'uploadAvatar',
    hidden: true,
    component: function component() {
      return import('@/views/user/uploadAvatar');
    }
  }, {
    path: 'createLargeScreen',
    name: 'createLargeScreen',
    hidden: true,
    component: function component() {
      return import('@/views/saleRecord/createLargeScreen');
    }
  }, {
    path: 'largeScreen',
    name: 'largeScreen',
    hidden: true,
    component: function component() {
      return import('@/views/saleRecord/largeScreen');
    }
  }, {
    path: 'createNotice',
    name: 'createNotice',
    hidden: true,
    component: function component() {
      return import('@/views/saleRecord/createNotice');
    }
  }, {
    path: 'addAwardee',
    name: 'addAwardee',
    hidden: true,
    component: function component() {
      return import('@/views/saleRecord/addAwardee');
    }
  }, {
    path: 'addHonorList',
    name: 'addHonorList',
    hidden: true,
    component: function component() {
      return import('@/views/saleRecord/addHonorList');
    }
  }]
}, {
  path: '/goodsCenter/adjustRule',
  component: Layout,
  // redirect: '/order/cardTypeManage',
  hidden: true,
  children: [{
    path: 'cinimaAdjustPriceRule',
    name: 'cinimaAdjustPriceRule',
    hidden: true,
    component: function component() {
      return import('@/views/goodsCenter/components/cinimaAdjustPriceRule');
    }
  }, {
    path: 'cinemaAdjustLog',
    name: 'CinemaAdjustLog',
    hidden: true,
    component: function component() {
      return import('@/views/goodsCenter/cinemaAdjustLog');
    }
  }, {
    path: 'cakeStoreAdjustLog',
    name: 'CakeStoreAdjustLog',
    hidden: true,
    component: function component() {
      return import('@/views/goodsCenter/cakeComponents/cakeStoreAdjustLog');
    }
  }, {
    path: 'cinemaAdjustRule',
    name: 'cinemaAdjustRule',
    hidden: true,
    component: function component() {
      return import('@/views/goodsCenter/cinemaAdjustRule');
    }
  }, {
    path: 'cakeHomeAdjustRuleList',
    name: 'cakeHomeAdjustRuleList',
    hidden: true,
    component: function component() {
      return import('@/views/goodsCenter/cakeHomeAdjustRuleList');
    }
  }, {
    path: 'cakeStoreAdjustRuleList',
    name: 'cakeStoreAdjustRuleList',
    hidden: true,
    component: function component() {
      return import('@/views/goodsCenter/cakeStoreAdjustRuleList');
    }
  }, {
    path: 'flowerAdjustRuleList',
    name: 'flowerAdjustRuleList',
    hidden: true,
    component: function component() {
      return import('@/views/goodsCenter/flowerAdjustRuleList');
    }
  }, {
    path: 'ticketAdjustRuleList',
    name: 'ticketAdjustRuleList',
    hidden: true,
    component: function component() {
      return import('@/views/goodsCenter/ticketAdjustRuleList');
    }
  }, {
    path: 'ticketAdjustLog',
    name: 'ticketAdjustLog',
    hidden: true,
    component: function component() {
      return import('@/views/goodsCenter/ticketAdjustLog');
    }
  }, {
    path: 'newPerformAdjustRuleList',
    name: 'newPerformAdjustRuleList',
    hidden: true,
    component: function component() {
      return import('@/views/goodsCenter/newPerformAdjustRuleList');
    }
  }, {
    path: 'newPerformAdjustLog',
    name: 'newPerformAdjustLog',
    hidden: true,
    component: function component() {
      return import('@/views/goodsCenter/newPerformAdjustLog');
    }
  }, {
    path: 'onlineDiscount',
    name: 'onlineDiscount',
    hidden: true,
    meta: {
      title: '在线点单设置折扣列表'
    },
    component: function component() {
      return import('@/views/goodsCenter/onlineComponents/onlineDiscount');
    }
  }, {
    path: 'addOnlineBrandsAdjustRule',
    name: 'addOnlineBrandsAdjustRule',
    hidden: true,
    meta: {
      title: '在线点单调价规则'
    },
    component: function component() {
      return import('@/views/goodsCenter/onlineComponents/addOnlineBrandsAdjustRule.vue');
    }
  }, {
    path: 'zydSetDiscount',
    name: 'zydSetDiscount',
    hidden: true,
    meta: {
      title: '自由兑设置折扣列表'
    },
    component: function component() {
      return import('@/views/goodsCenter/cakeComponents/zydSetDiscount');
    }
  }, {
    path: 'addZydAdjustRule',
    name: 'addZydAdjustRule',
    hidden: true,
    meta: {
      title: '自由兑调价规则'
    },
    component: function component() {
      return import('@/views/goodsCenter/cakeComponents/addZydAdjustRule.vue');
    }
  }, {
    path: 'zydAdjustLogList',
    name: 'zydAdjustLogList',
    hidden: true,
    meta: {
      title: '自由兑调价日志列表'
    },
    component: function component() {
      return import('@/views/goodsCenter/cakeComponents/zydAdjustLogList.vue');
    }
  }]
}, {
  path: '/order',
  component: Layout,
  redirect: '/order/cardTypeManage',
  hidden: true,
  meta: {
    icon: 'dingdan',
    title: '订单管理',
    roles: ['##']
  },
  children: [{
    path: 'createOrder',
    name: 'createOrder',
    hidden: true,
    component: function component() {
      return import('@/views/order/createOrder');
    },
    meta: {
      title: '创建订单'
    }
  }, {
    path: '/cardCommonConfig',
    name: 'cardCommonConfig',
    hidden: true,
    component: function component() {
      return import('@/views/order/cardCommonConfig');
    },
    meta: {
      title: '通用配置'
    }
  }, {
    path: 'creatGiftOrder',
    name: 'creatGiftOrder',
    hidden: true,
    component: function component() {
      return import('@/views/order/creatGiftOrder');
    },
    meta: {
      title: '创建礼包订单'
    }
  }, {
    path: 'orderDetails',
    name: 'orderDetails',
    hidden: true,
    component: function component() {
      return import('@/views/order/orderList/orderDetails');
    },
    meta: {
      title: '订单详情'
    }
  }, {
    path: 'sellCardList',
    name: 'sellCardList',
    hidden: true,
    component: function component() {
      return import('@/views/order/orderList/sellCardList');
    },
    meta: {
      title: '详情'
    }
  }, {
    path: 'exchangeRegister',
    name: 'exchangeRegister',
    hidden: true,
    component: function component() {
      return import('@/views/order/orderList/exchangeRegister');
    },
    meta: {
      title: '兑换登记表'
    }
  }, {
    path: 'auditManagement',
    name: 'auditManagement',
    hidden: true,
    component: function component() {
      return import('@/views/order/orderList/auditManagement');
    },
    meta: {
      title: '订单审核'
    }
  }, {
    path: 'paymentPlan',
    name: 'PaymentPlan',
    hidden: true,
    component: function component() {
      return import('@/views/order/orderList/paymentPlan');
    },
    meta: {
      title: '回款计划'
    }
  }, {
    path: 'fictitiousSellCardDetails',
    name: 'FictitiousSellCardDetails',
    hidden: true,
    component: function component() {
      return import('@/views/order/orderList/fictitiousSellCardDetails');
    }
  }, {
    path: 'sellCardDetails',
    name: 'SellCardDetails',
    hidden: true,
    component: function component() {
      return import('@/views/order/orderList/sellCardDetails');
    }
  }, {
    path: 'smsSendDetail',
    name: 'SmsSendDetail',
    hidden: true,
    component: function component() {
      return import('@/views/order/orderList/smsSendDetail');
    }
  }, {
    path: 'smsSendDetail',
    name: 'SmsSendDetail',
    hidden: true,
    component: function component() {
      return import('@/views/order/orderList/smsSendDetail');
    }
  }, {
    path: 'sendOutGoodsDetails',
    name: 'SendOutGoodsDetails',
    hidden: true,
    component: function component() {
      return import('@/views/order/orderList/sendOutGoodsDetails');
    },
    meta: {
      title: '发货详情'
    }
  }, {
    path: 'serviceReport',
    name: 'serviceReport',
    hidden: true,
    component: function component() {
      return import('@/views/order/serviceReport');
    },
    meta: {
      title: '礼包服务报告'
    }
  }, {
    path: 'workOrderDetail',
    name: 'WorkOrderDetail',
    hidden: true,
    component: function component() {
      return import('@/views/order/workOrderDetail');
    },
    meta: {
      title: '工单详情'
    }
  }, {
    path: 'createWorkOrder',
    name: 'createWorkOrder',
    hidden: true,
    component: function component() {
      return import('@/views/order/createWorkOrder');
    },
    meta: {
      title: '创建工单'
    }
  }]
},
// 客户订单
{
  path: '/customerOrder',
  component: Layout,
  hidden: true,
  redirect: '/customerOrder/orderList',
  meta: {
    icon: 'dingdan',
    title: '订单管理'
    // roles: ['/package/package-config/insert']
  },
  children: [{
    path: 'orderList',
    name: 'orderList',
    hidden: true,
    component: function component() {
      return import('@/views/customerOrder/orderList');
    },
    meta: {
      title: '订单列表'
    }
  }, {
    path: 'orderDetails',
    name: 'customerOrder/orderDetails',
    hidden: true,
    component: function component() {
      return import('@/views/customerOrder/orderDetails');
    },
    meta: {
      title: '订单详情'
    }
  }]
},
// 方案下礼包管理
{
  path: '/giftPackageManagement',
  component: Layout,
  hidden: true,
  children: [{
    path: 'index',
    name: 'giftBagIndex',
    component: function component() {
      return import('@/views/giftPackageManagement/index');
    },
    meta: {
      title: '礼包管理',
      activeMenu: '/index',
      keepAlive: true
    }
  }, {
    path: 'giftPackageDetails',
    name: 'giftPackageDetails',
    hidden: true,
    component: function component() {
      return import('@/views/giftPackageManagement/giftPackageDetails');
    },
    meta: {
      title: '',
      activeMenu: '/index'
    }
  }, {
    path: 'addGiftPackage',
    name: 'addGiftPackage',
    hidden: true,
    component: function component() {
      return import('@/views/giftPackageManagement/addGiftPackage');
    },
    meta: {
      title: '添加礼包',
      activeMenu: '/index'
    }
  }, {
    path: 'watchGiftPackageQuotationListDetails',
    name: 'watchGiftPackageQuotationListDetails',
    component: function component() {
      return import('@/views/giftPackageMultipleStatistics/watchGiftPackageQuotationListDetails');
    },
    meta: {
      title: '礼包商品多报价统计'
    }
  }, {
    path: 'multipleGoodsReplace',
    name: 'multipleGoodsReplace',
    component: function component() {
      return import('@/views/giftPackageMultipleStatistics/multipleGoodsReplace');
    },
    meta: {
      title: '商品替换列表'
    }
  }, {
    path: 'pageDecoration',
    name: 'pageDecoration',
    component: function component() {
      return import('@/views/schemeManage/components/pageDecoration');
    },
    meta: {
      title: '页面装修 '
    }
  }, {
    path: 'applyBusinessSupport',
    name: 'applyBusinessSupport',
    component: function component() {
      return import('@/views/schemeManage/components/applyBusinessSupport');
    },
    meta: {
      title: '商务列表 '
    }
  }, {
    path: 'checkGoods',
    name: 'checkGoods',
    component: function component() {
      return import('@/views/giftPackageManagement/checkGoods');
    },
    meta: {
      title: '核对商品信息 '
    }
  }, {
    path: 'checkGoodsDetails',
    name: 'checkGoodsDetails',
    component: function component() {
      return import('@/views/giftPackageManagement/components/checkGoodsDetails');
    },
    meta: {
      title: '核对商品信息详情'
    }
  }, {
    path: 'checkGoodsDetailsVersionTwo',
    name: 'checkGoodsDetailsVersionTwo',
    component: function component() {
      return import('@/views/giftPackageManagement/components/checkGoodsDetailsVersionTwo');
    },
    meta: {
      title: '核对商品信息详情'
    }
  }, {
    path: 'checkGoodsExamineDetails',
    name: 'checkGoodsExamineDetails',
    component: function component() {
      return import('@/views/giftPackageManagement/components/checkGoodsExamineDetails');
    },
    meta: {
      title: '捉虫结果审核'
    }
  }]
},
// 方案下礼包管理
{
  path: '/selectedGiftPackage',
  component: Layout,
  hidden: true,
  children: [{
    path: 'editSelectedGift',
    name: 'editSelectedGift',
    hidden: true,
    component: function component() {
      return import('@/views/schemeManage/editSelectedGift');
    },
    meta: {
      title: '编辑礼包'
    }
  }]
},
// 商城管理
{
  path: '/mallDecoration',
  component: Layout,
  hidden: true,
  children: [{
    path: 'addChannelMenu',
    name: 'addChannelMenu',
    component: function component() {
      return import('@/views/mallDecoration/addChannelMenu');
    },
    meta: {
      title: '添加实体菜单'
    }
  }, {
    path: 'manageProducts',
    name: 'manageProducts',
    component: function component() {
      return import('@/views/mallDecoration/manageProducts');
    },
    meta: {
      title: '管理商品'
    }
  }, {
    path: 'codeManageProducts',
    name: 'codeManageProducts',
    component: function component() {
      return import('@/views/mallDecoration/codeManageProducts');
    },
    meta: {
      title: '电子码管理商品'
    }
  }, {
    path: 'videoVipManageProducts',
    name: 'videoVipManageProducts',
    component: function component() {
      return import('@/views/mallDecoration/videoVipManageProducts');
    },
    meta: {
      title: '权益直充管理商品'
    }
  },
  // 二级菜单
  {
    path: 'cakeManageProducts',
    name: 'cakeManageProducts',
    component: function component() {
      return import('@/views/mallDecoration/cake/cakeManageProducts');
    },
    meta: {
      title: '蛋糕到家管理商品'
    }
  }, {
    path: 'secondaryMenuList',
    name: 'secondaryMenuList',
    component: function component() {
      return import('@/views/mallDecoration/secondaryMenuList');
    },
    meta: {
      title: '二级菜单管理'
    }
  },
  // 添加2级菜单
  {
    path: 'addSecondaryMenu',
    name: 'addSecondaryMenu',
    component: function component() {
      return import('@/views/mallDecoration/addSecondaryMenu');
    },
    meta: {
      title: '添加二级菜单'
    }
  }, {
    path: 'managedSecondaryProducts',
    name: 'managedSecondaryProducts',
    component: function component() {
      return import('@/views/mallDecoration/managedSecondaryProducts');
    },
    meta: {
      title: '二级菜单商品管理'
    }
  }, {
    path: 'cakeSecondaryProducts',
    name: 'cakeSecondaryProducts',
    component: function component() {
      return import('@/views/mallDecoration/cake/cakeSecondaryProducts');
    },
    meta: {
      title: '二级菜单蛋糕到家商品管理'
    }
  }, {
    path: 'watchOrderDetails',
    name: 'watchOrderDetails',
    component: function component() {
      return import('@/views/mallDecoration/watchOrderDetails');
    },
    meta: {
      title: '线上电影-订单详情'
    }
  }, {
    path: 'off_movie_details',
    name: 'off_movie_details',
    component: function component() {
      return import('@/views/orderCenter/components/off_movie_details');
    },
    meta: {
      title: '线下电影-订单详情'
    }
  }, {
    path: 'movie_offline_zyd_details',
    name: 'movie_offline_zyd_details',
    component: function component() {
      return import('@/views/orderCenter/components/movie_offline_zyd_details');
    },
    meta: {
      title: '电影自由兑-订单详情'
    }
  }, {
    path: 'entity_details',
    name: 'entity_details',
    component: function component() {
      return import('@/views/orderCenter/components/entity_details');
    },
    meta: {
      title: '商城-订单详情'
    }
  }, {
    path: 'package_details',
    name: 'package_details',
    component: function component() {
      return import('@/views/orderCenter/components/package_details');
    },
    meta: {
      title: '礼包兑换-订单详情'
    }
  }, {
    path: 'cake_details',
    name: 'cake_details',
    component: function component() {
      return import('@/views/orderCenter/components/cake_details');
    },
    meta: {
      title: '蛋糕到家-订单详情'
    }
  }, {
    path: 'cake_store_details',
    name: 'cake_store_details',
    component: function component() {
      return import('@/views/orderCenter/components/cake_store_details');
    },
    meta: {
      title: '蛋糕到店-订单详情'
    }
  }, {
    path: 'cake_store_sxd_details',
    name: 'cake_store_sxd_details',
    component: function component() {
      return import('@/views/orderCenter/components/cake_store_sxd_details');
    },
    meta: {
      title: '蛋糕自由兑-订单详情'
    }
  }, {
    path: 'off_cake_details',
    name: 'off_cake_details',
    component: function component() {
      return import('@/views/orderCenter/components/off_cake_details');
    },
    meta: {
      title: '线下蛋糕-订单详情'
    }
  }, {
    path: 'code_details',
    name: 'code_details',
    component: function component() {
      return import('@/views/orderCenter/components/code_details');
    },
    meta: {
      title: '电子卡密-订单详情'
    }
  }, {
    path: 'vipCard_details',
    name: 'vipCard_details',
    component: function component() {
      return import('@/views/orderCenter/components/vipCard_details');
    },
    meta: {
      title: '权益直充-订单详情'
    }
  }, {
    path: 'dudu_details',
    name: 'dudu_details',
    component: function component() {
      return import('@/views/orderCenter/components/dudu_details');
    },
    meta: {
      title: '线上演出-订单详情'
    }
  }, {
    path: 'lvmama_details',
    name: 'lvmama_details',
    component: function component() {
      return import('@/views/orderCenter/components/lvmama_details');
    },
    meta: {
      title: '景区门票-订单详情'
    }
  }, {
    path: 'online_foods_details',
    name: 'online_foods_details',
    component: function component() {
      return import('@/views/orderCenter/components/online_foods_details');
    },
    meta: {
      title: '在线点单-订单详情'
    }
  }, {
    path: 'mt_daodian_details',
    name: 'mt_daodian_details',
    component: function component() {
      return import('@/views/orderCenter/components/mt_daodian_details');
    },
    meta: {
      title: '美团到店-订单详情'
    }
  }, {
    path: 'mt_waimai_details',
    name: 'mt_waimai_details',
    component: function component() {
      return import('@/views/orderCenter/components/mt_waimai_details');
    },
    meta: {
      title: '美团外卖-订单详情'
    }
  }, {
    path: 'ding_d_details',
    name: 'ding_d_details',
    component: function component() {
      return import('@/views/orderCenter/components/ding_d_details');
    },
    meta: {
      title: '叮咚买菜-订单详情'
    }
  }, {
    path: 'yong_h_details',
    name: 'yong_h_details',
    component: function component() {
      return import('@/views/orderCenter/components/yong_h_details');
    },
    meta: {
      title: '叮咚买菜-订单详情'
    }
  }, {
    path: 'operationLogMall',
    name: 'operationLogMall',
    component: function component() {
      return import('@/views/mallDecoration/operationLogMall');
    },
    meta: {
      title: '操作日志'
    }
  }, {
    path: 'importGoodsLog',
    name: 'importGoodsLog',
    component: function component() {
      return import('@/views/mallDecoration/importGoodsLog');
    },
    meta: {
      title: '导入商品日志'
    }
  }, {
    path: 'menuLogList',
    name: 'menuLogList',
    component: function component() {
      return import('@/views/mallDecoration/menuLogList');
    },
    meta: {
      title: '个性化菜单操作日志'
    }
  }, {
    path: '/orderCenter/returnMoneyDetails',
    name: 'returnMoneyDetails',
    component: function component() {
      return import('@/views/orderCenter/returnMoneyDetails');
    },
    meta: {
      title: '退货退款'
    }
  }, {
    path: 'menuAdjustLogList',
    name: 'menuAdjustLogList',
    component: function component() {
      return import('@/views/mallDecoration/components/menuAdjustLogList');
    },
    meta: {
      title: '客户规则操作日志'
    }
  }, {
    path: 'thirdLevelMenuList',
    name: 'thirdLevelMenuList',
    component: function component() {
      return import('@/views/mallDecoration/thirdLevelMenu/thirdLevelMenuList');
    },
    meta: {
      title: '三级菜单管理'
    }
  },
  // 添加3级菜单
  {
    path: 'addThirdMenu',
    name: 'addThirdMenu',
    component: function component() {
      return import('@/views/mallDecoration/thirdLevelMenu/addThirdLevelMenu');
    },
    meta: {
      title: '添加三级菜单'
    }
  },
  // 3级菜单 管理商品
  {
    path: 'managedThirdProducts',
    name: 'managedThirdProducts',
    component: function component() {
      return import('@/views/mallDecoration/thirdLevelMenu/managedThirdProducts');
    },
    meta: {
      title: '添加三级菜单'
    }
  }, {
    path: 'priceAdjustmentRulesList',
    name: 'priceAdjustmentRulesList',
    component: function component() {
      return import('@/views/mallDecoration/components/priceAdjustmentRulesList');
    },
    meta: {
      title: '调价规则列表'
    }
  }, {
    path: 'priceAdjustmentRuleLogList',
    name: 'priceAdjustmentRuleLogList',
    component: function component() {
      return import('@/views/mallDecoration/components/priceAdjustmentRuleLogList');
    },
    meta: {
      title: '调价规则日志'
    }
  }, {
    path: 'KunlunGoods',
    name: 'KunlunGoods',
    component: function component() {
      return import('@/views/mallDecoration/KunlunGoods');
    },
    meta: {
      title: '昆仑好客-展示关联的品牌信息'
    }
  }]
}, {
  path: '/cardSystem/saleToos',
  component: Layout,
  hidden: true,
  redirect: '/cardSystem/saleToos',
  meta: {
    icon: 'kehuguanli',
    title: '销售工具',
    roles: ['/sales-tools']
  },
  children: [{
    path: '/cardSystem/directoryManagement/addDirectoryManagement',
    name: 'AddDirectoryManagement',
    component: function component() {
      return import('@/views/cardSystem/directoryManagement/addDirectoryManagement');
    },
    hidden: true,
    meta: {
      title: '知识库目录新建'
    }
  }, {
    path: '/cardSystem/knowledge/addKnowledge',
    name: 'AddKnowledge',
    component: function component() {
      return import('@/views/cardSystem/knowledge/addKnowledge');
    },
    hidden: true,
    meta: {
      title: '添加知识库',
      roles: ['/orders/knowledge/index']
    }
  }, {
    path: '/cardSystem/knowledge/viewKnowledge',
    name: 'ViewKnowledge',
    component: function component() {
      return import('@/views/cardSystem/knowledge/viewKnowledge');
    },
    hidden: true,
    meta: {
      title: '查看知识库',
      roles: ['/orders/knowledge/index']
    }
  }, {
    path: 'decodeLog',
    name: 'decodeLog',
    component: function component() {
      return import('@/views/cardSystem/saleToos/decodeLog');
    },
    hidden: true,
    meta: {
      title: '解码操作日志',
      roles: ['/sales/tools/get-code-log']
    }
  }]
}, {
  path: '/gift-pack',
  component: Layout,
  hidden: true,
  meta: {
    icon: 'libao',
    title: '礼包系统',
    roles: ['/package/package-programme/index']
  },
  children: [{
    path: 'giftPackageList',
    name: 'GiftPackageList',
    hidden: true,
    component: function component() {
      return import('@/views/giftPackage/giftPackageList');
    },
    meta: {
      title: '礼包管理详情'
    }
  }]
}, {
  path: '/cardSystem/goBackCardSys/backCardIndex',
  component: Layout,
  redirect: '/cardSystem/goBackCardSys/backCardIndex',
  hidden: true,
  meta: {
    icon: 'fanhui'
  },
  children: [{
    path: '/cardSystem/goBackCardSys/backCardIndex',
    name: 'backCardIndex',
    component: function component() {
      return import('@/views/cardSystem/goBackCardSys/backCardIndex');
    },
    meta: {
      title: '返回卡系统'
    },
    target: true
  }]
},
// 系统管理
{
  path: '/systemManagement/userManagement',
  component: Layout,
  hidden: true,
  redirect: '/systemManagement/userManagement/userManagementList',
  meta: {
    title: '系统管理',
    roles: ['/user/user/index']
  },
  children: [{
    path: '/systemManagement/userManagement/editUser',
    name: 'EditUserManagement',
    component: function component() {
      return import('@/views/systemManagement/userManagement/editUser');
    },
    hidden: true,
    meta: {
      title: '编辑用户'
    }
  }, {
    path: '/systemManagement/userManagement/createUserInfo',
    name: 'CreateUserInfo',
    component: function component() {
      return import('@/views/systemManagement/userManagement/createUserInfo');
    },
    hidden: true,
    meta: {
      title: '创建用户'
    }
  }, {
    path: '/systemManagement/userManagement/editRoles',
    name: 'EditUserPoles',
    component: function component() {
      return import('@/views/systemManagement/userManagement/editRoles');
    },
    hidden: true,
    meta: {
      title: '角色授权'
    }
  }, {
    path: '/systemManagement/userManagement/editData',
    name: 'EditData',
    component: function component() {
      return import('@/views/systemManagement/userManagement/editData');
    },
    hidden: true,
    meta: {
      title: '数据权限'
    }
  }, {
    path: '/systemManagement/userManagement/loginFlow',
    name: 'LoginFlow',
    component: function component() {
      return import('@/views/systemManagement/userManagement/loginFlow');
    },
    hidden: true,
    meta: {
      title: '日志'
    }
  }, {
    path: '/systemManagement/updateLogManage/logList',
    name: 'logList',
    component: function component() {
      return import('@/views/systemManagement/updateLogManage/logList');
    },
    hidden: true,
    meta: {
      title: '系统更新日志'
    }
  }, {
    path: '/systemManagement/updateLogManage/logDetail',
    name: 'logList',
    component: function component() {
      return import('@/views/systemManagement/updateLogManage/logDetail');
    },
    hidden: true,
    meta: {
      title: '系统更新日志详情'
    }
  }, {
    path: 'addDirectoryManagement',
    name: 'systemAddDirectoryManagement',
    component: function component() {
      return import('@/views/systemManagement/platformKnowledgeBase/addDirectoryManagement');
    },
    hidden: true,
    meta: {
      title: '知识库目录新建'
    }
  }, {
    path: 'platformKnowledgeBase',
    name: 'systemAddKnowledge',
    component: function component() {
      return import('@/views/systemManagement/platformKnowledgeBase/addKnowledge');
    },
    hidden: true,
    meta: {
      title: '添加知识库',
      roles: ['/orders/knowledge/index']
    }
  }, {
    path: 'viewKnowledge',
    name: 'systemViewKnowledge',
    component: function component() {
      return import('@/views/systemManagement/platformKnowledgeBase/viewKnowledge');
    },
    hidden: true,
    meta: {
      title: '查看知识库',
      roles: ['/orders/knowledge/index']
    }
  }, {
    path: 'menuRoleList',
    name: 'menuRoleList',
    component: function component() {
      return import('@/views/systemManagement/menuManagement/menuRoleList');
    },
    hidden: true,
    meta: {
      title: '菜单角色'
    }
  }, {
    path: '/systemManagement/userManagement/logList',
    name: 'logList',
    component: function component() {
      return import('@/views/systemManagement/userManagement/logList');
    },
    hidden: true,
    meta: {
      title: '访问日志'
    }
  }]
},
// 售卡管理
{
  path: '/cardSystem/cardSales',
  redirect: '/cardSystem/cardSales/cardSalesManagement',
  component: Layout,
  hidden: true,
  meta: {
    icon: 'shoukaguanli',
    title: '售卡管理',
    roles: ['/card/cardsale/index']
  },
  children: [{
    path: '/cardSystem/cardSales/applyInvoice',
    name: 'applyInvoice',
    component: function component() {
      return import('@/views/cardSystem/cardSales/applyInvoice');
    },
    hidden: true,
    meta: {
      title: '申请发票',
      roles: ['/card/cardsale/index']
    }
  }, {
    path: '/cardSystem/cardSales/continueInvoicing',
    name: 'continueInvoicing',
    component: function component() {
      return import('@/views/cardSystem/cardSales/continueInvoicing');
    },
    hidden: true,
    meta: {
      title: '继续开票',
      roles: ['/card/cardsale/index']
    }
  }, {
    path: '/salesCardManagement/createPrintingRecord',
    name: 'CreatePrintingRecord',
    component: function component() {
      return import('@/views//salesCardManagement/createPrintingRecord');
    },
    hidden: true,
    meta: {
      title: '创建印刷记录单',
      roles: ['/cardmake/card/add']
    }
  }, {
    path: '/settlementOrderDetails',
    name: 'settlementOrderDetails',
    component: function component() {
      return import('@/views//salesCardManagement/settlementOrderDetails');
    },
    hidden: true,
    meta: {
      title: '印刷结算单详情页'
    }
  }, {
    path: '/salesCardManagement/createSettlement',
    name: 'createSettlement',
    component: function component() {
      return import('@/views//salesCardManagement/createSettlement');
    },
    hidden: true,
    meta: {
      title: '创建印刷结算单'
    }
  }]
},
// 销售运营
{
  path: '/saleOperation',
  component: Layout,
  redirect: '/saleOperation/visitRecord',
  hidden: true,
  meta: {
    icon: 'saleOperation',
    title: '销售运营',
    roles: ['##']
  },
  children: [{
    path: 'visitRecord/visitAudit',
    name: 'visitRecord/visitAudit',
    meta: {
      title: '拜访记录审核'
    },
    component: function component() {
      return import('@/views/saleOperation/visitAudit/index');
    }
  }, {
    path: 'visitRecordCheck/visitCheck',
    name: 'visitRecordCheck/visitCheck',
    component: function component() {
      return import('@/views/saleOperation/visitCheck/index');
    },
    meta: {
      title: '拜访记录核查 '
    }
  }, {
    path: 'kayAccountDetail',
    name: 'kayAccountDetail',
    component: function component() {
      return import('@/views/saleOperation/kayAccountDetail');
    },
    meta: {
      title: '详情 '
    }
  }]
},
// 数据中心
{
  path: '/dataCenter',
  component: Layout,
  redirect: '/dataCenter',
  hidden: true,
  meta: {
    icon: '',
    title: '数据中心',
    roles: []
  },
  children: [{
    path: '/dataCenter/orderNumList',
    name: 'orderNumList',
    meta: {
      title: '支付订单列表'
    },
    component: function component() {
      return import('@/views/dataCenter/orderNumList');
    }
  }, {
    path: '/dataCenter/orderConsumptionTrend',
    name: 'dataCenterOrderConsumptionTrend',
    component: function component() {
      return import('@/views/dataCenter/orderConsumptionTrend');
    },
    meta: {
      title: '订单数据分析'
    }
  }]
},
// 客户管理
{
  path: '/cardSystem/customerManagement',
  component: Layout,
  redirect: '/customerManagement',
  hidden: true,
  meta: {
    icon: 'saleOperation',
    title: '客户管理',
    roles: ['/customer/customer/index']
  },
  children: [{
    path: '/customerManagement/editCustomer',
    name: 'editCustomer',
    meta: {
      title: '客户列表'
    },
    component: function component() {
      return import('@/views/cardSystem/customer/editCustomer');
    }
  }, {
    path: '/plat/customerManagement/editCustomer',
    name: 'editCustomer',
    meta: {
      title: '客户列表'
    },
    component: function component() {
      return import('@/views/platformConfig/customer/editCustomer');
    }
  }, {
    path: '/cardSystem/customer/custom-layout/home',
    component: function component() {
      return import('@/views/custom-layout/home');
    },
    meta: {
      title: '商城配置目录'
    }
  }, {
    path: '/customerManagement/log',
    name: 'editCustomer',
    meta: {
      title: '日志'
    },
    component: function component() {
      return import('@/views/cardSystem/customer/log');
    }
  }]
}, {
  path: '/saleCommission',
  component: Layout,
  // redirect: '/',
  hidden: true,
  meta: {
    icon: 'ticheng',
    title: '销售佣金',
    roles: ['##']
  },
  children: [{
    path: 'uploadRankDetail',
    name: 'uploadRankDetail',
    hidden: true,
    component: function component() {
      return import('@/views/saleCommission/uploadRankDetail');
    },
    meta: {
      title: '销售职级导入'
    }
  }, {
    path: 'rankLogList',
    name: 'rankLogList',
    hidden: true,
    component: function component() {
      return import('@/views/saleCommission/rankLogList');
    },
    meta: {
      title: '销售职级导入日志'
    }
  }, {
    path: 'rankDetailList',
    name: 'rankDetailList',
    hidden: true,
    component: function component() {
      return import('@/views/saleCommission/rankDetailList');
    },
    meta: {
      title: '职级详情列表'
    }
  }, {
    path: 'rankLogDetailList',
    name: 'rankLogDetailList',
    hidden: true,
    component: function component() {
      return import('@/views/saleCommission/rankLogDetailList');
    },
    meta: {
      title: '日志详情列表'
    }
  }, {
    path: 'commissionDetails',
    name: 'commissionDetails',
    hidden: true,
    component: function component() {
      return import('@/views/saleCommission/commissionDetails');
    },
    meta: {
      title: '佣金明细'
    }
  }]
},
// 分销渠道
{
  path: '/distribution',
  component: Layout,
  redirect: '/distribution',
  hidden: true,
  meta: {
    icon: 'ticheng',
    title: '分销渠道',
    roles: ['##']
  },
  children: [{
    path: 'distributionChangeBalance',
    name: 'distributionChangeBalance',
    component: function component() {
      return import('@/views/distribution/distributionChangeBalance');
    },
    meta: {
      title: '余额变动记录'
    }
  }, {
    path: 'distributionTransactionFlow',
    name: 'distributionTransactionFlow',
    component: function component() {
      return import('@/views/distribution/distributionTransactionFlow');
    },
    hidden: true,
    meta: {
      title: '交易流水'
    }
  }, {
    path: 'distributionOperationLog',
    name: 'distributionOperationLog',
    component: function component() {
      return import('@/views/distribution/distributionOperationLog');
    },
    hidden: true,
    meta: {
      title: '操作日志'
    }
  }]
}, {
  path: '/channelReport',
  component: Layout,
  redirect: '/channelReport',
  hidden: true,
  meta: {
    icon: 'ticheng',
    title: '渠道报表',
    roles: ['##']
  },
  children: [{
    path: 'channelReportOrderConsumptionTrend',
    name: 'channelReportOrderConsumptionTrend',
    hidden: true,
    component: function component() {
      return import('@/views/channelReport/orderConsumptionTrend');
    },
    meta: {
      title: '消费趋势'
    }
  }]
},
// 平台配置
{
  path: '/themeManage',
  component: Layout,
  hidden: true,
  children: [{
    path: 'popupSetDetail',
    name: 'popupSetDetail',
    component: function component() {
      return import('@/views/themeManage/popupSetDetail');
    },
    meta: {
      title: '弹窗设置'
    }
  }]
},
//荣联开放页面
{
  path: '/openRonglian',
  component: function component() {
    return import('@/views/openRonglian/index');
  },
  hidden: true
}];
var createRouter = function createRouter() {
  return new Router({
    // mode: 'history', // require service support
    scrollBehavior: function scrollBehavior() {
      return {
        y: 0
      };
    },
    routes: constantRoutes
  });
};
var router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}
export default router;